import React from 'react'
import ReactDOM from 'react-dom/client'

// lazy-load Maintenance component so dependencies aren't imported too early
const Maintenance = React.lazy(() => import('./pages/maintenance/maintenance'))

async function startApp() {
    const maintenanceEnd = process.env.REACT_APP_MAINTENANCE_WINDOW_END

    const isMaintenanceActive = typeof maintenanceEnd === 'string' && maintenanceEnd.trim().length > 0

    if (isMaintenanceActive) {
        const maintenanceHeader = 'Definitive Healthcare is currently under maintenance.'
        const maintenanceMessage = `This application will be unavailable until ${maintenanceEnd} due to scheduled maintenance. Please check back again after that time.`

        const container = document.createElement('div')
        document.body.appendChild(container)
        const root = ReactDOM.createRoot(container)
        root.render(<Maintenance header={maintenanceHeader} message={maintenanceMessage} />)
        return
    }

    await import('./bootstrap')
}

startApp()
